import React, { Component } from 'react'
import './css/index.css'
import {Button,Card,CardMedia,CardContent,} from '@material-ui/core'
import SliderCarousel from 'infinite-react-carousel';
import {
    ButtonBack, ButtonFirst, ButtonLast, ButtonNext,
    CarouselProvider, DotGroup, ImageWithZoom, Slide, Slider,
  } from 'pure-react-carousel'
import eventmanagement from '../../assets/image/banner-hompage1.jpg'
import Event1 from '../../assets/image/event1.jpg'
import Event2 from '../../assets/image/event2.jpg'
import Event3 from '../../assets/image/event3.jpg'
import assesment from '../../assets/image/home-services/assesment.jpg'
import digital from '../../assets/image/home-services/digital.jpg'
import learning from '../../assets/image/home-services/learning.jpg'
import strategy from '../../assets/image/home-services/strategy.jpg'

import img1 from '../../assets/image/home-services/1.png'
import img2 from '../../assets/image/home-services/2.png'
import img3 from '../../assets/image/home-services/3.png'
import img4 from '../../assets/image/home-services/4.png'
import img5 from '../../assets/image/home-services/5.png'
import img6 from '../../assets/image/home-services/6.png'

import img11 from '../../assets/image/home-services/1.1.jpg'
import img22 from '../../assets/image/home-services/2.2.jpg'
import img33 from '../../assets/image/home-services/3.3.jpg'
import img44 from '../../assets/image/home-services/4.4.jpg'
import img55 from '../../assets/image/home-services/5.5.jpg'
let data_consulting=[
    {
        title:"Strategy",
        content:"We help our clients in developing and implementing their strategy in order to improve performance and achieve growth.",
        img:Event1,
        link:'/services/consulting/strategy'
    },
    {
        title:"Structure",
        content:"We help our clients in developing and implementing strategy-based organization structure that ensure their employees work effectively to achieve  …",
        img:Event2,
        link:'/services/consulting/structur'
    },
    {
        title:"Change Management  & Culture",
        content:"We help our clients in identifying their pressing change issues, prioritizing and executing the areas for improvement in order to shape the organization …",
        img:Event1,
        link:'/services/consulting/change'
    },
    {
        title:"System",
        content:"We help our clients in developing and improving their business process that will deliver values and satisfaction to customers.",
        img:Event2,
        link:'/services/consulting/system'
    },
    {
        title:"People",
        content:"We help our clients in developing and implementing people best practices methodology that will contribute to the company’s future growth and sustainability.",
        img:Event3,
        link:'/services/consulting/people'
    },
    {
        title:"IT Strategic  Solution",
        content:"We help our clients in developing and enhancing their performance management and business productivity systems in order to make informed decision … ",
        img:Event1,
        link:'/services/consulting/it'
    }
]
let data_learning=[
    {
        title:"In-house Workshops",
        content:"Hundreds of organizations have been using our high quality in-class workshops for their training and development needs, with topics ranging from leadership …",
        img:Event1,
        link:'/services/learning/inhouse'
    },
    {
        title:"Certification Programs",
        content:"Lutan Edukasi Certification and Premium Products are complete sets of workshops to equip your people perform more effectively in your organization. The …",
        img:Event2,
        link:'/services/learning/certification'

    },
    {
        title:"Corporate University Services",
        content:"Our Corporate University services provide a complete set of services to support your Corporate University, from planning, preparing, and …",
        img:Event1,
        link:'/services/learning/corporate'

    },
    {
        title:"Blended Learning",
        content:"Training should not be a one-time activity. To ensure its effectiveness, researches have shown that Pre-Training Activities and Post-Training …",
        img:Event2,
        link:'/services/learning/blendedlearning'

    },
]
let data_eventmanagement=[
    {
        title:"Mega Seminar, Public Seminar, & Workshop",
        content:"We help you define your objectives, actualize your vision, and become your partner in managing your competency enhancement event.",
        img:Event1,
        link:'/services/eventmanagement/megaseminar'
    },
    {
        title:"Customer & Family Gathering, Team Building",
        content:"Whether planning a grand event or intimate gathering, we will supervise from site selection, theme development, menu selection, invitations, registrations, and executions.",
        img:Event2,
        link:'/services/eventmanagement/customerbuilding'
    },
    {
        title:"Product Launches",
        content:"We save your time and provide creative ideas to introduce new products, customize unique solutions and manage all your event details.",
        img:Event1,
        link:'/services/eventmanagement/productlaunch'
    },
    {
        title:"Corporate Meeting & Conference",
        content:"Special events with creative concepts & various themes. We provide superior services with details to create first-class events for large and small groups.",
        img:Event2,
        link:'/services/eventmanagement/corporatemeeting'
    },
    {
        title:"Artist / Speaker Management & Entertainment",
        content:"We manage all your requirements for hosting conferences and seminars.",
        img:Event3,
        link:'/services/eventmanagement/artist'
    },
    {
        title:"Themed and Custom Event",
        content:"Our experienced team has expertise in the industry and our valued network can deliver professional services.",
        img:Event1,
        link:'/services/eventmanagement/themeevvent'
    }
]
let data_digitallearning=[
    {
        title:"E-learning Platform Implementation",
        content:"We support your success in implementing e-learning platform initiative in your organization. Using a robust Learning Management System …",
        img:Event1,
        link:'/services/digitallearning/platform'
    },
    {
        title:"Infographic Animation (Motion Graphic)",
        content:"Design your information in an attractive way and gain the attention of your audiences with a simple animated simulation to delivered your objective.",
        img:Event2,
        link:'/services/digitallearning/motiongraphic'
    },
    {
        title:"Mobile Learning",
        content:"We always adapt with the latest technology-based learning methodology to keep pace with the shifting learning styles of the millennials.",
        img:Event1,
        link:'/services/digitallearning/mobilelearning'
    },
    {
        title:"E-Learning Content Development",
        content:"We also help you in creating and converting your conventional content delivery into interactive digital learning delivery to ensure your millennials keep engaging …",
        img:Event2,
        link:'/services/digitallearning/content'
    },
    {
        title:"e-Game for Class Activity",
        content:"Bored with conventional classroom learning methods? We are here to help you to enrich your conventional classroom learning methods with digital …",
        img:Event3,
        link:'/services/digitallearning/game'
    },
    {
        title:"Technical In-house Workshops for e-Learning Administrator …",
        content:"We share our knowledge and years of experiences as an e-learning implementor and practices in various industry and corporate. We will prepare …",
        img:Event1,
        link:'/services/digitallearning/workshops'
    }
]
let data_assestment=[
    {
        title:"Virtual Assessment Center",
        content:"We help our clients in developing and implementing their strategy in order to improve performance and achieve growth.",
        img:Event1,
        link:'/services/assesment/virtualassestmment'
    },
    {
        title:"Psychological Test",
        content:"We help our clients in developing and implementing strategy-based organization structure that ensure their employees work effectively to achieve  …",
        img:Event2,
        link:'/services/assesment/psychologi'
    },
    {
        title:"Assessment Center",
        content:"We help our clients in identifying their pressing change issues, prioritizing and executing the areas for improvement in order to shape the organization …",
        img:Event1,
        link:'/services/assesment/center'
    },
    {
        title:"Online Psychological Test",
        content:"We help our clients in developing and improving their business process that will deliver values and satisfaction to customers.",
        img:Event2,
        link:'/services/assesment/onlinetest'
    },
    {
        title:"Competency",
        content:"We help our clients in developing and implementing people best practices methodology that will contribute to the company’s future growth and sustainability.",
        img:Event3,
        link:'/services/assesment/compentency'
    },
]

let data_digital_human=[
    {
        title:"About CDHX",
        content:"<p>CDHX is founded by Indonesian and global leaders of digital and hr transformation who voluntarily serve as our board of advisors. Our programs are designed to deliver effective development of individual and corporate capabilities that would contribute to the vision of 2045 Indonesia Emas. </p> ",
        img:img11,
        link:'https://cdhx.gmlperformance.com/'
    },
    {
        title:"Volunteer Board of Advisors",
        content:"<p>Prof Dave Ulrich (Honorary Advisor)<br/>(Speaker, Author, Professor, Thought Partner on HR, Leadership, and Organization at The RLB group)<br/><br/>Prof Budi Sutjipto<br/>(Vice Rector  at Universitas Pertamina)<br/><br/>Irvandy Ferizal<br/>(Human Capital Director at Maybank)</p>",
        img:img22,
        link:'https://cdhx.gmlperformance.com/#volunteer'
    },
    {
        title:"Volunteer Board of Advisors",
        content:"<p>Lianawaty Soewono<br/>(Human Capital Director at PT. Bank Central  Asia Tbk)<br/><br/>Maria T. Kurniawati<br/>(HC Expert & ICF Certified Coach)<br/><br/>Dr. Paul Walsh<br/>(Program Director of BSC and Lean SIx Sigma practice at Australian Graduate School of Management)</p>",
        img:img33,
        link:'https://cdhx.gmlperformance.com/#volunteer'
    },
    {
        title:"Volunteer Board of Advisors",
        content:"<p>Samy Hussein<br/>(Country Manager HR at PT IBM Indonesia)<br/><br/>Suwardi Luis<br/>(CEO at ONE GML)<br/><br/>Dr. Yunus Triyonggo<br/>(Chairman at GNIK)</p>",
        img:img44,
        link:'https://cdhx.gmlperformance.com/#volunteer'
    },
    
    
    {
        title:"World-Class Curriculum",
        content:"<p>Curriculum designed and advised by the Father of Modern HR Science and world-class digital and HR Directors comprehensive academy from foundational, advanced to strategic digital and HR academy</p>",
        img:img1,
        link:'https://cdhx.gmlperformance.com/curiculum'
    },
    {
        title:"Top  Facilitators",
        content:"<p>Inspiring industrial practitioner  TOP speakers: HR and Digital Directors & Consultants</p>",
        img:img2,
        link:'https://cdhx.gmlperformance.com/#volunteer'
    },
    {
        title:"Experiential  Learning Method",
        content:"<p>Leading-edge framework with  practical skills and tools (30% theory + 70%  sharing, tools and practices)</p>",
        img:img3,
        link:'https://cdhx.gmlperformance.com/'
    },
    {
        title:"Accredited Certification",
        content:"<p>SKKNI accredited certifications by BNSP, Global Principal Certification</p>",
        img:img4,
        link:'https://cdhx.gmlperformance.com/'
    },
    {
        title:"Post-Workshop Coaching & Collaboration",
        content:"<p>Blended learning approach combining online learning, offline discussions and post-workshop coaching Alumni forum, resource portal, and HR clinics for peer coaching & benchmark</p>",
        img:img5,
        link:'https://cdhx.gmlperformance.com/'
    },
    {
        title:"Impact Building",
        content:"<p>Alumni community contributing to  Corporate Social Responsibility (CSR) & nation building</p>",
        img:img6,
        link:'https://cdhx.gmlperformance.com/'
    },
    {
        title:"Dave Ulrich HR Academy is a program designed and owned by RBL Group",
        content:"<p>“ Congratulations … with CDHX, I work to advance the HR profession anywhere in the world because I think human capital create more successful organizations that succeed in the marketplace. Given that commitment, I would like to support your good work in Indonesia”</p>",
        img:img55,
        link:'https://cdhx.gmlperformance.com/'
    },
]
export default class services_carousel extends Component {
    state={
        tabs_active:'consulting',
        active_index:0,
    }
    tabsToggle=(key)=>{
        this.setState({tabs_active:key})
    }
    imageToggle=(index)=>{
        this.setState({active_index:index})
    }
    render() {
        const {tabs_active}=this.state
        // console.log('sdf')
        return (
            <div>
                <section className='services'>
                    <h2>Our Services</h2>
                    <br/>
                    <div className='tab' >
                        <Button  onClick={()=>this.tabsToggle('consulting')} color="primary" className="tab-btn-home-consulting" size="small" variant={tabs_active==="consulting"?'outlined':''} >Strategy & Organization</Button>
                        <Button   onClick={()=>this.tabsToggle('learning')}color="primary" className="tab-btn-home-learning"  variant={tabs_active==="learning"?'outlined':''}>Learning</Button>
                        <Button  onClick={()=>this.tabsToggle('event')}color="primary" className="tab-btn-home-event" variant={tabs_active==="event"?'outlined':''}>Event Management</Button>
                        <Button  onClick={()=>this.tabsToggle('assesment')}color="primary" className="tab-btn-home-assestment" variant={tabs_active==="assesment"?'outlined':''}>Assessment Center</Button>
                        <Button  onClick={()=>this.tabsToggle('digital')}color="primary" className="tab-btn-home-digital" variant={tabs_active==="digital"?'outlined':''}>Digital Learning</Button>
                        <Button  onClick={()=>this.tabsToggle('digital_human')}color="primary" className="tab-btn-home-digital-human" variant={tabs_active==="digital_human"?'outlined':''}>Digital & Human Transformation</Button>
                    </div>
                    <div style={{display:tabs_active==='consulting'?'':'none'}}>
                    
                    <div className="content-services" >
                    
                        {/* <div className="dot-services"></div>
                        <div className="dot-services2"></div> */}
                        <div className='services1'>
                            <img src={strategy} className="services-img"/>
                        </div>
                        <SliderCarousel  dots arrows={false} className='slider-homepage'>
                            {data_consulting.map((data,i)=>(
                                <>
                                
                                <div className='services1-content'>
                                    {/* <h3>Strategy and Organization Services</h3>
                                    <br/> */}
                                    <h2>{data.title}</h2>
                                    <br/>
                                    <p>{data.content}</p>
                                    <br/><br/>
                                    <Button onClick={()=>window.location.assign(data.link)} style={{textTransform:'none',fontWeight:'bold'}} color="primary">Read more detail</Button>
                                </div>
                                </>
                            ))}
                           
                            
                        </SliderCarousel>
                    </div>

                   
                </div>
                    <div style={{display:tabs_active==='learning'?'':'none'}}>
                    <div className="content-services" >
                    
                        {/* <div className="dot-services"></div>
                        <div className="dot-services2"></div> */}
                        <div className='services1'>
                            <img src={learning} className="services-img"/>
                        </div>

                        <SliderCarousel dots arrows={false} className='slider-homepage'>
                            {data_learning.map((data,i)=>(
                                <div className='services1-content' key={i}>
                                {/* <h3>Learning Services</h3>
                                <br/> */}
                                <h2>{data.title}</h2>
                                <br/>
                                <p>{data.content}</p>
                                <br/>
                                <Button onClick={()=>window.location.assign(data.link)} style={{textTransform:'none',fontWeight:'bold'}} color="primary">Read more detail</Button>
                            </div>
                            ))}
                           
                            
                        </SliderCarousel>
                    </div>
                    
                </div>
                    <div style={{display:tabs_active==='event'?'':'none'}}>
                    <div className="content-services" >
                    
                        {/* <div className="dot-services"></div>
                        <div className="dot-services2"></div> */}
                        <div className='services1'>
                            <img src={eventmanagement} className="services-img"/>
                        </div>

                        <SliderCarousel dots arrows={false} className='slider-homepage'>
                            {data_eventmanagement.map((data,i)=>(
                                <div className='services1-content' key={i}>
                                {/* <h3>Event Management Services</h3>
                                <br/> */}
                                <h2>{data.title}</h2>
                                <br/>
                                <p>{data.content}</p>
                                <br/>
                                {/* <Button onClick={()=>window.location.assign(data.link)} style={{textTransform:'none',fontWeight:'bold'}} color="primary">Read more detail</Button> */}
                            </div>
                            ))}
                           
                            
                        </SliderCarousel>
                    </div>
                   
                </div>
                <div style={{display:tabs_active==='assesment'?'':'none'}}>
                    <div className="content-services" >
                    
                        {/* <div className="dot-services"></div>
                        <div className="dot-services2"></div> */}
                        <div className='services1'>
                            <img src={assesment} className="services-img"/>
                        </div>

                        <SliderCarousel dots arrows={false} className='slider-homepage'>
                            {data_assestment.map((data,i)=>(
                                <div className='services1-content' key={i}>
                                {/* <h3>Assesment Services</h3>
                                <br/> */}
                                <h2>{data.title}</h2>
                                <br/>
                                <p>{data.content}</p>
                                <br/>
                                <Button onClick={()=>window.location.assign(data.link)} style={{textTransform:'none',fontWeight:'bold'}} color="primary">Read more detail</Button>
                            </div>
                            ))}
                           
                            
                        </SliderCarousel>
                    </div>
                    
                </div>
                <div style={{display:tabs_active==='digital'?'':'none'}}>
                    <div className="content-services" >
                    
                        {/* <div className="dot-services"></div>
                        <div className="dot-services2"></div> */}
                        <div className='services1'>
                            <img src={digital} className="services-img"/>
                        </div>

                        <SliderCarousel dots arrows={false} className='slider-homepage'>
                            {data_digitallearning.map((data,i)=>(
                                <div className='services1-content' key={i}>
                                {/* <h3>Digital Learning Services</h3>
                                <br/> */}
                                <h2>{data.title}</h2>
                                <br/>
                                <p>{data.content}</p>
                                <br/>
                                <Button onClick={()=>window.location.assign(data.link)} style={{textTransform:'none',fontWeight:'bold'}} color="primary">Read more detail</Button>
                            </div>
                            ))}
                           
                            
                        </SliderCarousel>
                    </div>
                   
                </div>
                <div style={{display:tabs_active==='digital_human'?'':'none'}}>
                    <div className="content-services" >
                    
                        
                        {/* <div className='services1'>
                            <img src={data_digital_human[this.state.active_index].img} className="services-img"/>
                        </div>

                        <Slider afterChange={(i)=>this.imageToggle(i)} dots arrows={false} className='slider-homepage-cdex'>
                            {data_digital_human.map((data,i)=>(
                                <div className='services1-content-cdex' style={{display:'flex!important'}} key={i}>
                                
                                <h2>{data.title}</h2>
                                <br/>
                                <p dangerouslySetInnerHTML={{__html:data.content}}></p>
                                <br/>
                                <Button onClick={()=>window.location.assign(data.link)} style={{textTransform:'none',fontWeight:'bold'}} color="primary">Read more detail</Button>
                            </div>
                            ))}
                           
                            
                        </Slider> */}
                        
                         <CarouselProvider
                            naturalSlideWidth={100}
                            naturalSlideHeight={31}
                            totalSlides={data_digital_human.length}
                            // style={{marginTop:20}}
                        >
                            <Slider>
                                {data_digital_human.map((data,i)=>(
                                    <Slide index={i}>
                                        <div className='cdex-slider'>
                                            <div className='cdex-slider-img-container'>
                                                <img src={data.img} className='cdex-slider-img'/>
                                            </div>
                                            <div className='cdex-slider-content'>
                                                <div s>
                                                    <h2>{data.title}</h2>
                                                    <br/>
                                                    <div dangerouslySetInnerHTML={{__html:data.content}}></div>
                                                    <br/>
                                                    <Button onClick={()=>window.location.assign(data.link)} style={{textTransform:'none',fontWeight:'bold'}} color="primary">Read more detail</Button>
                                                </div>
                                                
                                                <div style={{position:'absolute',top:320,left:560}}>
                                                    <DotGroup className='dot-slider'/>
                                                </div>

                                            </div>
                                        </div>
                                    </Slide>
                                ))}
                            
                            </Slider>
                        </CarouselProvider>
                    </div>
                   
                </div>
                </section>
            </div>
        )
    }
}
